import {
  makeStyles
} from '@material-ui/core'
import React, { useMemo, useContext, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { TASContext } from 'src/store/cia/tas'
import { COLOR } from '../helper'
import ErrorDialog from 'src/components/clog/dialog/ErrorDialog'

import CngTabBar from 'src/components/clog/misc/CngTabBar'

const useStyles = makeStyles(theme => ({
  origin: {
    borderColor: COLOR.origin + ' !important'
  },
  destination: {
    borderColor: COLOR.destination + ' !important'
  }
}))

function TabBar(props) {
  const classes = useStyles()
  const {
    activeDirection,
    setDirection,
    isOriginLoading, isDestinationLoading, requestType,
    originTree,
    destinationTree
  } = useContext(TASContext)

  const [isDialogOpen, setDialogOpen] = useState(false)
  const [dialogMessage, setDialogMessage] = useState('')

  const activeTab = useMemo(() =>
    activeDirection === 'origin' ? 0 : 1
  , [activeDirection])

    const handleTabChange = i => {
    let targetDirection = ''
    
    if(requestType === 'import' && i === 0) {
      targetDirection = 'destination'
    } else if(requestType === 'export' && i === 0) {
      targetDirection = 'origin'
    } else {
      targetDirection = i === 0 ? 'origin' : 'destination'
    }

    // Check if data is available for the target direction
    const targetTree = targetDirection === 'origin' ? originTree : destinationTree
    const hasData = targetTree && targetTree.data && targetTree.data.results && targetTree.data.results.length > 0
    
    if (!hasData) {
      let message = `No result available.\nPlease retry with the following:  \n\n1. Shorten the HS code to the first 6 digits \n2. Enter an item description`
      setDialogMessage(message)
      setDialogOpen(true)
      return // Don't switch tab
    }
    
    setDirection(targetDirection)
  }

  const closeDialog = () => {
    setDialogOpen(false)
    setDialogMessage('')
  }

  function getTab() {
    let tabList = []
    if(requestType == "both" || requestType == "export") {
      let tab = {
        label: `Origin - ${props.origin || ''}`,
        selectedClass: classes.origin,
        disabled: isOriginLoading,
        icon: isOriginLoading ? <FontAwesomeIcon icon={['fal', 'spinner-third']} fixedWidth spin /> : null
      }
      tabList.push(tab)
    }

    if(requestType == "both" || requestType == "import") {
      let tab = {
        label: `Destination - ${props.destination || ''}`,
        selectedClass: classes.destination,
        disabled: isDestinationLoading,
        icon: isDestinationLoading ? <FontAwesomeIcon icon={['fal', 'spinner-third']} fixedWidth spin /> : null
      }
      tabList.push(tab)
    }

    return tabList
  }

    return (<>
    <CngTabBar
      textColor='inherit'
      value={activeTab}
      tabs={getTab()}
      onActiveTabChanged={handleTabChange}
    />
    
    <ErrorDialog
      open={isDialogOpen}
      onClose={closeDialog}
      title="Error"
      message={dialogMessage}
    />
  </>)
}

export default TabBar
